import { DuplicateIcon } from "../components/icons-svg";
import copyToClipboard from "copy-to-clipboard"
import React, { useState } from "react";
import Tooltip from "../components/tooltip";


export default function CopyToClipboardComponent({text}) {
  var defaultCopyTip="Copy to clipboard"
  var [copyTip,setCopyTip]=useState(defaultCopyTip)
  
  function copy(){
    copyToClipboard(text)
    setCopyTip("Copied!")
    setTimeout(()=>{
      try { // in timeout might be an error of updating unmounted component
        setCopyTip(defaultCopyTip)
      } catch(err) {
        const noop=function(){}
        noop() // eslint don't allow empty blocks
      }
    },2000)
  }
  return <Tooltip tip={copyTip}>
  <span onClick={copy} css={`@media print {display:none;}`}>
    {DuplicateIcon(16)}
  </span>
</Tooltip>
}